import { render, staticRenderFns } from "./addCoupons.vue?vue&type=template&id=cb7400ca"
import script from "./addCoupons.vue?vue&type=script&lang=js"
export * from "./addCoupons.vue?vue&type=script&lang=js"
import style0 from "./addCoupons.vue?vue&type=style&index=0&id=cb7400ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports